import { NgModule } from '@angular/core';
import { SharedModule } from '~app/app/~shared/modules/shared.module';
import { AdvertiserSectorListListDatatableComponent } from './components/advertiser-sector-list-datatable/advertiser-sector-list-datatable.component';

const DECLARATIONS = [AdvertiserSectorListListDatatableComponent];

const MODULES = [SharedModule];

@NgModule({
  declarations: DECLARATIONS,
  imports: [...MODULES],
  exports: [...MODULES, ...DECLARATIONS],
  providers: []
})
export class AdvertiserSectorModule {}
